import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'cf2-top-app-bar',
    templateUrl: './top-app-bar-component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TopAppBarComponent {}
